"use client";

import { X, Crown } from "lucide-react";
import Image from "next/image";
import { getTrialRemainingDays } from "../lib/pass-utils";

interface TrialActivatedModalProps {
  isOpen: boolean;
  onClose: () => void;
  freeTrialExpiresAt?: string | null;
}

export default function TrialActivatedModal({
  isOpen,
  onClose,
  freeTrialExpiresAt,
}: TrialActivatedModalProps) {
  if (!isOpen) return null;

  const remainingDays = freeTrialExpiresAt
    ? getTrialRemainingDays(freeTrialExpiresAt)
    : 0;

  return (
    <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <div className="bg-white dark:bg-gray-900 rounded-xl max-w-sm w-full shadow-2xl">
        {/* 헤더 */}
        <div className="flex items-center justify-between p-4 border-b dark:border-gray-700">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <Crown className="w-5 h-5 text-yellow-500" />
            Premium 무료체험 활성화
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* 내용 */}
        <div className="p-6 text-center">
          <Image
            src="/main/happy_gamza.webp"
            alt="기뻐하는 감자"
            width={140}
            height={140}
            className="mx-auto mb-4"
          />

          <p className="text-gray-700 dark:text-gray-300 text-base leading-relaxed mb-2">
            Premium 기능을 무료로 체험해 보세요!
          </p>

          {remainingDays > 0 && (
            <div className="inline-flex items-center gap-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-sm font-medium px-3 py-1.5 rounded-full mb-4">
              <span>{remainingDays}일</span> 동안 이용 가능
            </div>
          )}

          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 text-left space-y-2">
            <p className="text-sm text-gray-600 dark:text-gray-400 font-medium mb-2">
              체험 기간 동안 이용 가능한 기능:
            </p>
            {[
              "문제 풀이 이력 저장",
              "오답 노트 작성",
              "문제 저장 (북마크)",
              "공부 진행상황 체크",
            ].map((feature) => (
              <p
                key={feature}
                className="text-sm text-gray-600 dark:text-gray-400 flex items-center gap-2"
              >
                <span className="text-green-500">&#10003;</span>
                {feature}
              </p>
            ))}
          </div>
        </div>

        {/* 푸터 */}
        <div className="flex justify-center p-4 border-t dark:border-gray-700">
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-primary text-white rounded-lg hover:bg-primary/80 transition-colors font-medium"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
